// @flow
import * as React from 'react';
import type { ValidationError } from './Validator';

type ValidatedFieldProps = {
  field: string,
  errors: Array<ValidationError>,
  children?: React.Node,
};

const ValidatedField = (props: ValidatedFieldProps) => {
  const errors = props.errors.filter(e => e.field === props.field);

  return (
    <div className={errors.length && 'danger'}>
      {props.children}
      {errors.map(error => (
        <span className="errorMessage" key={error.message}>
          {error.message}
        </span>
      ))}
    </div>
  );
};

export default ValidatedField;



// WEBPACK FOOTER //
// ./src/components/Validation/ValidatedField.js